import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { t } from 'i18next';
import { useTenant } from '@/lib/auth/tenant-context';
import { useImpersonationExchange } from '@/lib/auth/use-impersonation-exchange';
import { Loader2 } from 'lucide-react';
import { PROTECTED, DASHBOARD, SIGN_IN } from '@/lib/constants/routes';
import { impersonateSearchSchema } from '@/routes/-shared/impersonate-search-schema';
import { readImpersonationHandoffToken } from '@/lib/auth/impersonation-handoff';

export const Route = createFileRoute('/impersonate')({
  validateSearch: impersonateSearchSchema,
  component: ImpersonatePage,
});

function ImpersonatePage() {
  const navigate = useNavigate();
  const { token: searchToken, tenant: tenantId } = Route.useSearch();
  const token = readImpersonationHandoffToken() ?? searchToken ?? null;
  const { setSelectedTenant } = useTenant();

  useImpersonationExchange({
    token,
    tenantId,
    onTenantSelected: setSelectedTenant,
    onSuccess: () => navigate({ to: `${PROTECTED}${DASHBOARD}` }),
    onFailure: (error) => {
      console.error('Impersonation setup failed:', error);
      navigate({ to: SIGN_IN });
    },
  });

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
        <p>{t('auth.impersonation_loading', 'auth')}</p>
      </div>
    </div>
  );
}
